import { useEffect, useRef } from 'react';

// The API strips iframe `src` to `data-src` so embeds never auto-load.
// On mount we replace each deferred iframe with a click-to-load shield.
// The user opts in by clicking, which restores the `src` and the embed loads.
export function ArticleBody({ html }: { html: string }) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const root = ref.current;
    if (!root) return;
    const iframes = Array.from(root.querySelectorAll<HTMLIFrameElement>('iframe[data-src]'));
    for (const iframe of iframes) {
      const src = iframe.getAttribute('data-src');
      if (!src) continue;

      const placeholder = document.createElement('button');
      placeholder.type = 'button';
      placeholder.className = 'iframe-shield';
      placeholder.setAttribute('aria-label', 'انقروا لتحميل المحتوى المضمَّن');
      placeholder.style.cssText = [
        'display:block',
        'width:100%',
        'min-height:200px',
        'background:#f3f3f4',
        'border:1px solid #e5e7eb',
        'border-radius:6px',
        'cursor:pointer',
        'font-family:inherit',
        'font-size:14px',
        'color:#515A60',
        'padding:24px',
        'text-align:center',
        'margin:1em 0',
      ].join(';');
      placeholder.innerHTML =
        '<div style="font-weight:600;margin-bottom:6px">محتوى مضمَّن</div>' +
        '<div style="font-size:12px;color:#7e7e7e">انقروا للتحميل</div>';
      placeholder.addEventListener(
        'click',
        () => {
          iframe.setAttribute('src', src);
          iframe.removeAttribute('data-src');
          placeholder.replaceWith(iframe);
        },
        { once: true },
      );
      iframe.replaceWith(placeholder);
    }
  }, [html]);

  return (
    <div className="post-text mt-1">
      <div ref={ref} className="tiptap-content" dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
